export { default } from "./PlayerAvatarView";
